import { Div, H1, P } from "./styled";
import { StyledList } from "./List/styled";

const WhyUs = () => {
  return (
    <div>
      <StyledList>
        <Div>
          <H1>Wsparcie</H1>
          <P>
            AI wspiera Cię w codziennych zadaniach: dając Ci ulepszoną wyszukiwarkę internetową, układając dietę, tworząc posty, artykuły, a nawet dokumenty prawne, co zwiększa Twoją efektywność i oszczędza czas.
          </P>
        </Div>
        <Div>
          <H1>Przewaga</H1>
          <P>
              Agenci AI stworzą posty na social media, przygotują scenariusze do rolek, a nawet pomogą w odpowiadaniu na komentarze – dzięki nim działasz z wyprzedzeniem i zyskujesz przewagę w biznesie.
          </P>
        </Div>
        <Div>
          <H1>Przyszłość</H1>
          <P>
            Asystenci AI już teraz: Tworzą zdjęcia,
            wideo i rolki, a nawet gotowe piosenki. A to dopiero początek! Możesz zwiększać swój potencjał influencerski narzędziami, które będą powszechne dopiero za kilka lat!
          </P>
        </Div>
      </StyledList>
    </div>
  );
};

export default WhyUs;
